import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from "../../assign-prescriptions/images/spinner.gif";
import {
  Grid,
  Box,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  AppBar,
  Button,
  DialogActions,
  Avatar,
} from "@mui/material";
import moment from "moment-timezone";
import { withTranslation } from "react-i18next";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from "@mui/icons-material/Close";

const styles = (theme) => ({
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
});

const TransactionSortObj = {
  first_name: { tableName: "users", sortColumn: "first_name" },
  last_name: { tableName: "users", sortColumn: "last_name" },
  stock_code: { tableName: "prescriptions_master", sortColumn: "stock_code" },
  pucode: { tableName: "prescriptions_master", sortColumn: "pucode" },
  location: { tableName: "boxes", sortColumn: "name" },
  created_on: { tableName: "", sortColumn: "created_on" },
};

let TransactionFilterObj = {
  searchObject: null,
  fromdate: "",
  todate: "",
  pageNo: 0,
  pageSize: 25,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class AuditReportComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 25,
      loader: false,
      data: [],
      userdetail: "",
    };
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem("i18nextLng");
    let zone;
    zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === "en"
      ? date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("MM/DD/YYYY hh:mm:ss A")
      : date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("DD/MM/YYYY hh:mm:ss A");
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = this.getServerSideDatasource();
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  };

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.fromdate = "";
      TransactionFilterObj.todate = "";
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = () => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(
          params.request.startRow / self.state.rowsPerPage
        );

        const filterObject = params.request && params.request.filterModel;
        const filterColumns = Object.keys(filterObject);

        // to set fromdate and todate
        if (filterObject.created_on) {
          const dateValue = filterObject.created_on;
          if (dateValue.operator) {
            // for date range
            if (
              dateValue.condition1.type === "fromdate" &&
              dateValue.condition2.type === "todate"
            ) {
              const date1 = moment(dateValue.condition1.dateFrom).format(
                "YYYY-MM-DD"
              );
              const date2 = moment(dateValue.condition2.dateFrom).format(
                "YYYY-MM-DD"
              );
              TransactionFilterObj.fromdate = date1;
              TransactionFilterObj.todate = date2;
            }
            if (
              dateValue.condition2.type === "fromdate" &&
              dateValue.condition1.type === "todate"
            ) {
              const date2 = moment(dateValue.condition1.dateFrom).format(
                "YYYY-MM-DD"
              );
              const date1 = moment(dateValue.condition2.dateFrom).format(
                "YYYY-MM-DD"
              );
              TransactionFilterObj.fromdate = date1;
              TransactionFilterObj.todate = date2;
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format("YYYY-MM-DD");
            if (dateValue.type === "fromdate") {
              TransactionFilterObj.fromdate = date;
              TransactionFilterObj.todate = "";
            } else {
              TransactionFilterObj.todate = date;
              TransactionFilterObj.fromdate = "";
            }
          }
        } else {
          TransactionFilterObj.todate = "";
          TransactionFilterObj.fromdate = "";
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null;
          } else {
            TransactionFilterObj.searchObject = filterObject;
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName =
            TransactionSortObj[params.request.sortModel[0].colId].tableName;
          TransactionFilterObj.sortColumn =
            TransactionSortObj[params.request.sortModel[0].colId].sortColumn;
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort;
        }

        apiCall();

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + "audit_report", {
            method: "post",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((res) => {
              try {
                return res.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results });
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [] });
                }
              } else {
                params.successCallback([], 0);
                self.setState({ data: [] });
              }
              self.setState({ loader: false });
            })
            .catch((error) => {
              self.setState({ loader: false });
              console.error(error);
              params.failCallback();
            });
        }
      },
    };
  };

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value);
  };

  handleClick = (event, pm) => {
    event.preventDefault();
    console.log(pm)
    this.setState({ detailDialogOpen: true, userdetail: pm });
  };

  handleClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false,})
  }

  LinkValueRenderer = (params) => {
    return (
      <a
        href=""
        title="View Pick up by"
        style={{
          color: "#385cad",
          fontWeight: 500,
          textDecoration: "none ",
          fontSize: "1rem",
        }}
        onClick={(event) => this.handleClick(event, params.data)}
      >
        {params.value}
      </a>
    );
  };

  render() {
    const { classes, t } = this.props;
    const { data, userdetail } = this.state;

    const columnDefs = [
      { field: "first_name", headerName: t("Report.Transaction.FirstName") },
      { field: "last_name", headerName: t("Report.Transaction.LastName") },
      { field: "stock_code", headerName: t("Report.Transaction.StockCode") },
      { field: "pucode", headerName: t("Report.Transaction.PUCode") },
      { field: "location", headerName: t("Report.Picked.Location") },
      {
        field: "description",
        sortable: false,
        headerName: t("Location.Description"),
        cellRenderer: this.LinkValueRenderer,
      },
      {
        field: "created_on",
        headerName: t("Report.phiLogs.CreatedOn"),
        cellRenderer: this.DateCellFormatter,
        filter: "agDateColumnFilter",
        filterParams: {
          filterOptions: [
            {
              displayKey: "fromdate",
              displayName: t("Report.phiLogs.FromDate"),
              predicate: (_, cellValue) => cellValue,
            },
            {
              displayKey: "todate",
              displayName: t("Report.phiLogs.ToDate"),
              predicate: (_, cellValue) => cellValue,
            },
          ],
          maxNumConditions: 2,
        },
      },
    ];

    return (
      <div>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <div id="react-no-print">
          <Dialog
            open={this.state.detailDialogOpen || false}
            PaperProps={{
              style: { borderRadius: "5px", width: "40%" },
            }}
          >
            <AppBar
              position="static"
              color="default"
              sx={{
                backgroundColor: "#00a7e1",
                color: "white",
                padding: "4px",
                fontWeight: "bold",
              }}
            >
              {t("Users.UserDetails.UserDetailsTitle")}
            </AppBar>
            <DialogContent>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div>
                  <Avatar
                    style={{
                      borderRadius: "0%",
                      width: "150px",
                      height: "150px",
                    }}
                    alt=""
                    src={
                      userdetail.picture_url !== null &&
                        userdetail.picture_url !== ""
                        ? userdetail.picture_url
                        : "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg"
                    }
                  />
                </div>
                <div style={{ padding: "25px" }}>
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.UserName")} :
                    </span>
                    {userdetail.name}
                  </p>
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.Email")} :
                    </span>
                    {userdetail.email}
                  </p>
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.Phone")} :
                    </span>
                    {userdetail.phone}
                  </p>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  this.handleClose(e);
                }}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Report.Picked.Temperature.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <Box component="div">
          <Grid
            container
            direction={"row"}
            alignItems={"center"}
            justifyContent={"flex-end"}
            spacing={0}
            sx={{
              ml: 0,
              mr: 1,
              width: "100%",
              border: "solid 1px #babfc7",
              borderBottom: "none",
            }}
          >
            <Tooltip
              key="clear-filters"
              title={t("Report.phiLogs.ClearFiltersTooltip")}
            >
              <IconButton
                onClick={() => this.clearFilters()}
                style={{ backgroundColor: "#00a7e1" }}
              >
                <CloseIcon style={{ color: "white" }} />
              </IconButton>
            </Tooltip>
          </Grid>
        </Box>
        <ReportsAGGrid
          columnDefs={columnDefs}
          sideBar={false}
          suppressMenuHide={true}
          rowData={data}
          defaultColDef={{
            flex: 1,
            minWidth: 150,
            floatingFilter: true,
            filter: "agTextColumnFilter",
            filterParams: {
              filterOptions: [
                {
                  displayKey: "searchtext",
                  displayName: "Search Text",
                  predicate: (cellValue) => cellValue,
                },
              ],
              maxNumConditions: 1,
            },
            resizable: true,
            sortable: true,
            menuTabs: ["generalMenuTab", "columnsMenuTab"],
          }}
          onGridReady={this.onGridReady}
        />
      </div>
    );
  }
}

AuditReportComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(AuditReportComponent));



// WEBPACK FOOTER //
// ./src/components/reports/audit-report/index.js